import { Controller } from 'stimulus';
import csrfToken from '../helpers/csrfToken';
import laravelErrorsToListHtml from '../helpers/laravelErrorsToListHtml';

class WorkingAtSubmit extends Controller {
  // eslint-disable-next-line class-methods-use-this
  onSubmit(event) {
    event.preventDefault();
  }

  async onValid() {
    this.lockForm();

    try {
      const formData = await this.formDataFromForm();
      const res = await this.postFormData(formData);

      if (res.status === 201) {
        window.location.href = this.data.get('success-url');
        return;
      }

      const jsonBody = await res.json();

      const errors = typeof jsonBody.errors !== 'undefined' ? jsonBody.errors : [];
      this.outputErrors(errors);
    } catch (err) {
      this.outputErrors(['Something went wrong.']);

      // eslint-disable-next-line no-console
      console.log(err);
    }

    this.unlockForm();
  }

  /**
   * @param {String[]|Object.<string, String[]>} errors
   */
  outputErrors(errors) {
    const errorsHtml = laravelErrorsToListHtml(errors);

    this.errorsTarget.innerHTML = errorsHtml;

    this.errorsTarget.style.display = errorsHtml.length ? 'block' : 'none';
    this.errorsTarget[errorsHtml.length ? 'setAttribute' : 'removeAttribute']('aria-live', 'assertive');
  }

  /**
   * @param {FormData} formData
   * @returns {Promise<Response>}
   */
  postFormData(formData) {
    return fetch(this.data.get('api'), {
      method: 'POST',
      headers: {
        // This will make sure Laravel recognizes this request as being ajax.
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': csrfToken(),
      },
      body: formData,
      credentials: 'same-origin',
    });
  }

  /**
   * @returns {Promise<FormData>}
   */
  formDataFromForm() {
    return new Promise((resolve) => {
      resolve(new FormData(this.element));
    });
  }

  lockForm() {
    this.toggleFormLock(true);
  }

  unlockForm() {
    this.toggleFormLock(false);
  }

  toggleFormLock(state) {
    this.submitTarget[state ? 'setAttribute' : 'removeAttribute']('disabled', 'disabled');

    this.overlayTarget.style.opacity = state ? 1 : 0;
    this.overlayTarget.style.visibility = state ? 'visible' : 'hidden';
  }
}

WorkingAtSubmit.targets = [
  'submit',
  'errors',
  'overlay',
];

export default WorkingAtSubmit;
